
import { useEffect, useState } from 'react';
import { Image } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import "./assets/OpenNews.scss";
import { Link, Navigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { api, url } from '../host';
import { useStore } from '../store/Store';
import http from '../components/ui/Services';




function OpenCategories() {
    const { t } = useTranslation();
    const params = useParams();
    const { id } = params;
    const [error, seterror]=useState(false)
    const Categories=useStore(state=>state.Categories)
    const setCategories=useStore(state=>state.setCategories)
    const [idT, setidT] = useState<any>(Number(id))
    useEffect(()=>{
      if(Categories===null){
          http.get<any>(`/GetApi/GetCategoriesApi/`)
        .then((res) => {
          setCategories(res.data);
        if(!res.data[idT]){
          seterror(true)
        }
        })
          .catch(e => console.log(e))
      }
  
  },[])

     return (

        <div className="open-sports" style={{padding:'50px 18%'}}>{
            error?<Navigate to="/kasblar" />:
            Categories!==null?<div className="container" >
            <Row >
<Col lg={17} md={24} sm={24}>

<div className="open-sports-title">
                {Object.keys(Categories[idT]).length !== 0 &&
                  <h5>{t('lang') === 'uz' ? Categories[idT].titleUz : Categories[idT].titleRu}</h5>
  
                }
            </div>
          
            <Image.PreviewGroup>
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          navigation={true}
          className="mySwiper"
        >
          <SwiperSlide>
          <div
                    className="swiper-slide_body"
                   style={{
                 
                      display:'flex',
                      alignItems:'center',
                      justifyContent:'center',
                
                      
                   }}
                  >
                    <Image className='red' style={{height:'auto', width:"100%" }} src={`${api}/Files/Categories/${Categories[idT].titleImage}`}/>  
                  </div>
                  </SwiperSlide>
              
              {Categories[idT].CategoriesImage && Categories[idT].CategoriesImage.length!==0?Categories[idT].CategoriesImage.map((item: any, index: any)=>{
                  return(<SwiperSlide><div
                    className="swiper-slide_body"
                    style={{
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center',
                        }}
                  >
                         <Image className='red' style={{height:'auto', width:"100%"}} src={`${api}/Files/Categories/${item.imageUrl}`}/>  
                  </div>
                   </SwiperSlide>)

              }):''}
            
         
         
          
          
        </Swiper>

            <div className="open-sports-text">
               
                    <p className='salomText' style={{textAlign:'justify', lineHeight:"2", fontSize:'18px', textIndent:'50px'}} dangerouslySetInnerHTML={{__html: t('lang') === 'uz' ? Categories[idT].mainTextUz : Categories[idT].mainTextRu}}/>
               
            </div>
        </Image.PreviewGroup>
</Col>
<Col lg={7} md={0} sm={0} className="opensportitemCol">
<ul className="opensportitem">
   <h4>{t("Categories")}</h4>
   
   {Categories.map((item:any, key:any)=>{
       return( <li onClick={()=>{setidT(key)}}>
       <div  className="news_list-item1" key={key}>
        <div className='titles'>             
        <p className='tabTitle' style={{textTransform:'uppercase'}}>{t('lang') === 'uz' ? item.titleUz : item.titleRu}</p>
        </div></div>
        </li>)
   })}

</ul>
    </Col>

            </Row>
  
<br/>
<br/>

        </div>:<></>
         }
          
        </div>
    )
}

export default OpenCategories;